import React from "react";
import { SyncOutlined } from "@ant-design/icons";
import "./CakeOCard.css";
// import Moment from "react-moment";
import Moment from "react-moment";
// import axios from "axios";

import { useState, useEffect } from "react";

import { toast } from "react-toastify";
import { axiosInstance } from "../../config";

// const formatDate = Moment().format('DD-MM-YYYY')
const CakeOCard = () => {
  const [pastries, setPastries] = useState([{}]);
  const [count, setCount] = useState(0);
  const [search, setSearch] = useState();

  useEffect(() => {
    try {
      const fetchCake = async () => {
        const orderdata = await axiosInstance.get("/api/mymy");
        setPastries(orderdata.data.allcake);
        // setCupCake(orderdata.data.allcupcake);
        // setDoughnut(orderdata.data.alldoughnut);
      };
      fetchCake();
    } catch (err) {
      toast.error(err.response.data);
    }
  }, [count]);
  const handledDelete = async (index) => {
    const answer = window.confirm(
      "Are you sure you want to delete?, Miriam i cannot retrieve any info after you delete lol.."
    );
    if (!answer) return;
    let allcakes = pastries;
    const removed = allcakes.splice(index, 1);
    // setPastries(allcakes);
    console.log("all", allcakes);
    const { data } = await axiosInstance.put(`api/mymy/deletecake`, {
      id: removed[0]._id,
    });
    setCount(() => count + 1);
    console.log("lesson deleted", data);
    // console.log("rmv", removed[0]._id);
  };
  // console.log("object", pastries);
  console.log(search);

  //search

  const searchItems = (e) => {
    e.preventDefault();
    const results = pastries.filter((item) => {
      return Object.values(item)
        .join("")
        .toLowerCase()
        .includes(search.toLowerCase());
    });
    setPastries(results);
  };
  const refresh = (e) => {
    try {
      const fetchCake = async () => {
        const orderdata = await axiosInstance.get("/api/mymy");
        setPastries(orderdata.data.allcake);
        // setCupCake(orderdata.data.allcupcake);
        // setDoughnut(orderdata.data.alldoughnut);
      };
      fetchCake();
    } catch (err) {
      toast.error(err.response.data);
    }
  };
  return (
    <>
      <h3 className="coc-heading">Cake Orders</h3>
      <input
        className="search"
        name="Search"
        type="text"
        placeholder="Search"
        onChange={(e) => setSearch(e.target.value)}
      />
      <button onClick={searchItems}>Go</button>
      <button onClick={refresh}>Return</button>
      <div className="coc-main">
        {pastries ? (
          pastries.map((pastry, index) => (
            <div key={index} className="coc-card-main">
              {/* <h1>{Moment(pastry.updatedAt).format("DD-MM-YYYY HH:mm")}</h1> */}
              <h1>
                <Moment>{pastry.updatedAt}</Moment>
              </h1>
              <div className="coc-card">
                <div className="coc-details">
                  <h1 className="coc-label">Name: </h1>
                  <h1 className="coc-value">{pastry.name}</h1>
                  {/* <h1>;</h1> */}
                </div>
                <div className="coc-details">
                  <h1 className="coc-label">Contact: </h1>
                  <h1 className="coc-value">{pastry.contact}</h1>
                </div>
                <div className="coc-details">
                  <h1 className="coc-label">Writing On Cake: </h1>
                  <h1 className="coc-value">
                    {pastry.writingoncake
                      ? pastry.writingoncake
                      : "no writings"}
                  </h1>
                </div>
                <div className="coc-details">
                  <h1 className="coc-label">Shape: </h1>
                  <h1 className="coc-value">
                    {pastry.shape ? pastry.shape : "No shape"}
                  </h1>
                </div>
                <div className="coc-details">
                  <h1 className="coc-label">Flavour: </h1>
                  <h1 className="coc-value">{pastry.flavour}</h1>
                </div>
                <div className="coc-details">
                  <h1 className="coc-label">Size: </h1>
                  <h1 className="coc-value">{pastry.size + " pounds"}</h1>
                </div>
                <div className="coc-details">
                  <h1 className="coc-label">Extras: </h1>
                  {pastry.extras
                    ? pastry.extras.map((extra) => (
                        <h1 key={extra} className="coc-value">
                          {extra + ","}
                        </h1>
                      ))
                    : "No Extras"}
                </div>
                <div className="coc-details">
                  <h1 className="coc-label">Delivery Method: </h1>
                  <h1 className="coc-value">{pastry.delivery}</h1>
                </div>
                <div className="coc-details">
                  <h1 className="coc-label">Total: </h1>
                  <h1 className="coc-value">{pastry.price + " GHC"}</h1>
                </div>
              </div>
              <button onClick={() => handledDelete(index)}>Delete</button>
            </div>
          ))
        ) : (
          <SyncOutlined spin />
        )}
      </div>
    </>
  );
};

export default CakeOCard;
